import { useContext } from "react";
import { add, IObj2d } from "../../models/IObj";
import { hasDimensions } from "../../services/CabinetValidator";
import { FrontPosConverter } from "../../util/PosConverter";
import { DrawContext } from "../EditorCommon/DrawContext";
import { CommonEditorProps, EditorContext } from "../EditorCommon/EditorContext";
import { ImageOutline } from "../EditorCommon/ImageOutline";

const minFrameDisplaySize = 2;

export function DoorImageFront(props: {
    onClickDoor?: ((doorIndex: number) => void),
}) {
    const ec = useContext(EditorContext);
    const drawContext = useContext(DrawContext);

    const cabinet = ec.cabinet;
    if (!hasDimensions(cabinet))
        throw new Error("dimensions not defined");

    const convert = new FrontPosConverter(cabinet.height!);


    const doorInfos = ec.cabinetService.getDoorInfos()
        .sort((a, b) => a.railNumber - b.railNumber); //sort by railNumber, so the inner doors are drawn first

    const doorGroups = doorInfos.map((door) => {


        const fillings = door.fillingElements.map((filling, fillingIndex) => {
            return (
                <g className="door-filling"
                    key={fillingIndex}
                >
                    <image xlinkHref={filling.textureUrl}
                        {...convert.size(filling.size)}
                        {...convert.pos(add(filling.position, door.position), filling.size)}
                        preserveAspectRatio={drawContext.preserveAspectRatio}
                    />
                </g>
            );
        });

        const frames = door.frameElements.map((frame, frameIndex) => {
            var size = {
                x: Math.max(minFrameDisplaySize, frame.size.x),
                y: Math.max(minFrameDisplaySize, frame.size.y),
            };
            return (
                <g className="door-frame"
                    key={frameIndex}
                    data-frame-name={frame.frameName}
                >
                    <image xlinkHref={frame.textureUrl}
                        {...convert.size(size)}
                        {...convert.pos(add(frame.position, door.position), size)}
                        preserveAspectRatio={drawContext.preserveAspectRatio}
                    />
                </g>
            );
        });

        //display info about damping
        const dampingStatus = ec.cabinetService.getDampingStatus(door.index);

        function getDampingProps() {
            switch (dampingStatus) {
                case "notAvailableOnDoorType":
                    return undefined;
                case "tooNarrow":
                    return undefined;
                    //return {
                    //    text: ec.translator("door image front damping too narrow", "Denne dør er for\nsmal til at installere\ndæmper"),
                    //    width: 360,
                    //    height: 190
                    //};
                case "deactivated":
                    return undefined;
                    //return {
                    //    text: ec.translator("door image front damping deactivated", "Ingen dæmpning"),
                    //    width: 360,
                    //    height: 60
                    //};
                case "activated":
                    return {
                        text: ec.translator("door image front damping activated", "Dæmpning"),
                        width: 250,
                        height: 60
                    };
                    
            }
        }
        const dampingProps = getDampingProps();
        const doorMidX = door.position.x + (door.size.x / 2);
        const dampingInfo = (dampingProps)
            ? (<g>
                <rect stroke="rgb(40,40,40)"
                    fill="rgba(128,128,128,0.3)"
                    x={doorMidX - (dampingProps.width / 2)}
                    y={60}
                    width={dampingProps.width}
                    height={dampingProps.height}
                />
                <text x={doorMidX} y={100}
                    textAnchor="middle"
                    fontSize={40}
                    style={{ whiteSpace: "pre-line" }} >
                    {dampingProps.text}
                </text>
            </g>
            ): undefined;

        //only display overlay if there's a click-action
        const overlay = props.onClickDoor ? (
            <rect className="clickable door-overlay"
                {...convert.size(door.size)}
                {...convert.pos(door.position, door.size)}
                onClick={() => props.onClickDoor?.(door.index)}
            />
        ) : undefined;

        return (
            <g className="door"
                key={door.index}
                data-door-index={door.index}
            >
                {fillings}
                <rect {...convert.obj(door)} {...ImageOutline} />
                {frames}
                {dampingInfo}
                {overlay}
            </g>
        );
    });




    return (
        <g>
            {doorGroups}
        </g>
    );
}

export module DoorImageFront {
    export function boundingBox(ec: CommonEditorProps): IObj2d {
        const cabinet = ec.cabinet;
        if (!hasDimensions(cabinet))
            throw new Error("dimensions not defined");
        const mainBox: IObj2d = {
            position: { x: 0, y: 0 },
            size: { x: cabinet.width, y: cabinet.height }
        }
        return mainBox;
    }
}
